import { JobseekerStatisticsDto, PaginationQuery, Pagination, JobseekerAdminFindOneDto } from '@libs/dto';

import { Jobseeker } from '@libs/models';
import { api } from '../common.api';

export const jobseekerAdminApi = api.injectEndpoints({
  endpoints: (build) => ({
    jobseekerStatistics: build.query<JobseekerStatisticsDto, void>({
      query: () => ({
        url: '/jobseeker/admin/statistics',
        method: 'GET',
      }),
    }),
    jobseekerAdminSearch: build.query<Pagination<Jobseeker>, PaginationQuery>({
      query: ({ q, page = 1, limit = 10 }) => ({
        url: '/jobseeker/admin/search',
        method: 'GET',
        params: { q, page, limit },
      }),
    }),
    jobseekerAdminFindOne: build.query<JobseekerAdminFindOneDto, string>({
      query: (id) => ({
        url: `/jobseeker/admin/${id}`,
        method: 'GET',
      }),
      providesTags: ['Jobseeker'],
    }),
  }),
});

export const {
  useJobseekerStatisticsQuery,
  useJobseekerAdminSearchQuery,
  useLazyJobseekerAdminSearchQuery,
  useJobseekerAdminFindOneQuery,
} = jobseekerAdminApi; 